<capra-breadcrumbs
  class="breadcrumbs"
  *ngIf="breadcrumbItems?.length"
  [breadcrumbs]="breadcrumbItems"
  [displayMode]="displayMode === DisplayMode.Menu ? 'menu' : 'dropdown'"
  (breadcrumbClicked)="onClick($event)"
>
  <ng-content breadcrumbs-name-prefix select="[mode-breadcrumbs-name-prefix]"></ng-content>
</capra-breadcrumbs>
